import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  ui_template_id: null,
  project_ui_template_id: null,
  project_details: [],
  schedule_details: [],
  tab_sequence: [],
  template_name: '',
  removed_field: '',
  fields_list: [],
  customProjectFieldsMap: {},
};

const projectLayoutConfigSlice = createSlice({
  name: 'projectLayoutConfig',
  initialState: initialState,
  reducers: {
    setProjectLayoutConfig(state, { payload }) {
      state.ui_template_id = Object.prototype.hasOwnProperty.call(
        payload,
        'ui_template_id'
      )
        ? payload.ui_template_id
        : state.ui_template_id;
      state.project_ui_template_id = Object.prototype.hasOwnProperty.call(
        payload,
        'project_ui_template_id'
      )
        ? payload.project_ui_template_id
        : state.project_ui_template_id;
      state.project_details = Object.prototype.hasOwnProperty.call(
        payload,
        'project_details'
      )
        ? payload.project_details
        : state.project_details;
      state.schedule_details = Object.prototype.hasOwnProperty.call(
        payload,
        'schedule_details'
      )
        ? payload.schedule_details
        : state.schedule_details;
      state.tab_sequence = Object.prototype.hasOwnProperty.call(
        payload,
        'tab_sequence'
      )
        ? payload.tab_sequence
        : state.tab_sequence;
      state.template_name = Object.prototype.hasOwnProperty.call(
        payload,
        'template_name'
      )
        ? payload.template_name
        : state.template_name;
      state.removed_field = Object.prototype.hasOwnProperty.call(
        payload,
        'removed_field'
      )
        ? payload.removed_field
        : state.removed_field;
      state.fields_list = Object.prototype.hasOwnProperty.call(
        payload,
        'fields_list'
      )
        ? payload.fields_list
        : state.fields_list;
      state.customProjectFieldsMap = Object.prototype.hasOwnProperty.call(
        payload,
        'customProjectFieldsMap'
      )
        ? payload.customProjectFieldsMap
        : state.customProjectFieldsMap;
    },
  },
});

export const { setProjectLayoutConfig } = projectLayoutConfigSlice.actions;

export const projectLayoutConfigReducer = projectLayoutConfigSlice.reducer;
